import Button from "components/base/Button";
import Product from "components/shared/Product";
import ProductSelector from "components/shared/ProductSelector";
import { useModals } from "ModalProvider";
import { useContext, useEffect, useState } from "react";
import { GTMProjectContext } from "../GTMProjectContext";

const RunningChangeProductsView = () => {
  const { originalGTMProject, autoSave, saveProjectRes } =
    useContext(GTMProjectContext);
  const modal = useModals();
  const [sourceProduct, setSourceProduct] = useState(
    originalGTMProject.sourceProduct,
  );

  useEffect(() => {
    setSourceProduct(originalGTMProject.sourceProduct);
  }, [originalGTMProject.sourceProduct]);

  function chooseProduct() {
    modal.present({
      title: "Choose Product",
      children: (
        <ProductSelector
          onSelect={(product) => {
            setSourceProduct(product);
            autoSave({
                id: originalGTMProject.id,
                input: { sourceProductId: product.id },
            });
            modal.hide();
          }}
        />
      ),
    });
  }

  return (
    <div className="card">
      <h5>Source Product</h5>
      <div className="mt-2">
        <div className="mb-3">
          {sourceProduct ? (
            <Product
              name={sourceProduct.name}
              number={sourceProduct.number}
              version={sourceProduct.version}
            />
          ) : (
            <div className="opacity-70">No source product linked.</div>
          )}
        </div>
        <div>
          <Button onClick={chooseProduct} loading={saveProjectRes.loading}>
            {sourceProduct ? "Change Product" : "Choose Product"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RunningChangeProductsView;
